import { render } from "./CpuCompute.vue?vue&type=template&id=4948ac52&scoped=true"
import script from "./CpuCompute.vue?vue&type=script&lang=js"
export * from "./CpuCompute.vue?vue&type=script&lang=js"

import "./CpuCompute.vue?vue&type=style&index=0&id=4948ac52&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4948ac52"]])

export default __exports__